// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanEditController = function ($rootScope, $scope, $location, $routeParams, Plan, PlanByPlanGroup, TaxPolicy, ProductInfo, CustomFieldSettings, gettext) {

    $scope.EscalationFallbackPopoverText =
        gettext('The Fallback-Planvariant that can be selected here will be automatically assigned to the contract that has not paid after a defined period of time. This setting must be defined separately in "Settings-Payment- Payment Escalation" with the action "Switch to Fallback".');

    function fillFallbackPlanInfo(expectedPlanPropertyName, planVariantPropertyName, planData) {
        if (planData[planVariantPropertyName]) {
            var planVariant = $scope.productInfo.PlanVariantById(planData[planVariantPropertyName]);
            planData[expectedPlanPropertyName] = planVariant.PlanId;
            $scope[expectedPlanPropertyName] = planVariant.PlanId;
        }
    }

    $scope.productInfo = ProductInfo.get(function () {
        if ($routeParams.planId) {
            $scope.plan = Plan.get({planId: $routeParams.planId},
                function (planData) {
                    fillFallbackPlanInfo('FallbackPlanId', 'FallbackPlanVariantId', planData);
                    fillFallbackPlanInfo('CancellationFallbackPlanId', 'CancellationFallbackPlanVariantId', planData);
                    fillFallbackPlanInfo('EscalationFallbackPlanId', 'EscalationFallbackPlanVariantId', planData);
                }
            );
            TaxPolicy.query().$promise.then(function (result) {
                $scope.taxPolicies = result;
            });
        } else {
            $scope.plan = new PlanByPlanGroup();
            $scope.plan.CustomFields = {};
            $scope.plan.SetupDescription = {_c: "Setup"};
            $scope.plan.TrialEndPolicy = 'NoTrial';
            $scope.plan.PlanGroupId = $routeParams.planGroupId;
            TaxPolicy.query().$promise.then(function (result) {
                $scope.taxPolicies = result;
                $scope.plan.TaxPolicyId = TaxPolicy.getDefaultTaxPolicyId($scope.taxPolicies);
                $scope.plan.SetupTaxPolicyId = TaxPolicy.getDefaultTaxPolicyId($scope.taxPolicies);
            });
        }
    });


    CustomFieldSettings.get({ customFieldType: 'Product' }, function (data) {
        $scope.customFieldSettings = data.CustomFieldDescriptors;
    });

    $scope.currentPlanId = $routeParams.planId;

    function finish() {
        $location.path("/products");
    };

    $scope.save = function () {

        if (!$rootScope.isValid($scope.form))
            return;

        // check trial values
        if ($scope.plan.TrialEndPolicy == 'NoTrial') {
            $scope.plan.TrialPeriod = undefined;
            $scope.plan.TrialEndNotificationPeriod = undefined;
        }
        else {
            var period = $scope.plan.TrialPeriod;
            if (period && (period.Quantity < 0 ||
                (period.Quantity > 0 &&
                (!period.Unit || !$scope.plan.TrialEndPolicy)))) {
                return;
            }
        }

        if ($routeParams.planId)
            $scope.plan.$update({ planId: $routeParams.planId }, finish);
        else
            $scope.plan.$save({ planGroupId: $scope.plan.PlanGroupId }, finish);
    };

    $scope.cancel = function () { $location.path("/products"); };


    $scope.filterPlans = function (plan) {
        return plan.Id !== $scope.currentPlanId;
    }

    $scope.hasVisibleCustomFields = function () {
        if (!$scope.customFieldSettings)
            return false;
        for (var i = 0; i < $scope.customFieldSettings.length;i++) {
            if ($scope.customFieldSettings[i].EditInUI != 'None')
                return true;
        }
        return false;
    }
    
    $scope.$watch('plan.CancellationFallbackPlanId', function () {
        if($scope.plan && !$scope.plan.CancellationFallbackPlanId)
            $scope.plan.CancellationFallbackPlanVariantId = '';
    }, true);

    $scope.onSwitchOrderApproval = function () {
        $scope.plan.RequiresOrderApproval = !$scope.plan.RequiresOrderApproval;
    }

};
PlanEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', 'Plan', 'PlanByPlanGroup', 'TaxPolicy', 'ProductInfo', 'CustomFieldSettings', 'gettext'];
